import React from "react";
//#region types
import { ProjectCategoryStatusTagsProps } from "models/propTypes/timeReportingProjectPropTypes";
import { Tags } from "components/common";
import { TranslationKeys } from "translations";
//#endregion
//#region components
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ProjectCategoryStatusTags: React.FC<ProjectCategoryStatusTagsProps> = (props) => {
  const { category } = props;

  const getLabel = () => {
    return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.Standard);
  };

  return category.isDefault ? <Tags tags={[getLabel()]} className={cssExports.greenTag} /> : null;
};

export default ProjectCategoryStatusTags;
